import z from "zod";

export const authenticationSchema = z.object({
  username: z
    .string({ message: "Este campo é obrigatório. (min: 4)" })
    .min(4, "Este campo é obrigatório. (min: 4)"),
  password: z
    .string({ message: "Este campo é obrigatório. (min: 4)" })
    .min(4, "Este campo é obrigatório. (min: 4)")
});

export const authenticationResponseSchema = z.object({
  access_token: z.string(),
  token_type: z.string(),
  expires_in: z.number(),
  strNome: z.string(),
  strUsuario: z.string(),
  ".issued": z.string(),
  ".expires": z.string()
});

export type AuthenticationType = z.infer<typeof authenticationSchema>;
export type AuthenticationResponseType = z.infer<
  typeof authenticationResponseSchema
>;
